export enum TaggingTypeEnum {
  VIEW = 'view',
  ACTION = 'action',
}
